import { SearchField } from '@/shared/ui/search/AdvancedSearch/types/field.types';
import { useAdvancedSearchTheme } from '@/shared/ui/search/AdvancedSearch/theme/useAdvancedSearchTheme';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

interface IProps {
  value: string;
  fields: readonly SearchField[];
  onChange: (fieldName: string) => void;
  label?: string;
}

export function FieldSelect({ value, fields, onChange, label = '필드' }: IProps) {
  const { fieldSelectSx } = useAdvancedSearchTheme();

  return (
    <FormControl sx={fieldSelectSx} size="small">
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={(e) => onChange(e.target.value)}>
        {fields.map((field) => (
          <MenuItem key={field.name} value={field.name}>
            {field.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
